import { get, destroy, upload, uploadPut, put } from 'utils/fetchRequest';

export const getTestimonials = async () => {
    try {
        return await get('testimonials');
    } catch (err) {
        return { error: err };
    }
};

export const getTestimonial = async (id) => {
    try {
        return await get(`testimonials/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createTestimonial = async (formData) => {
    try {
        return await upload('testimonials', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateTestimonial = async (id, formData) => {
    try {
        return await uploadPut(`testimonials/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteTestimonial = async (id) => {
    try {
        return await destroy(`testimonials/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const reorderTestimonials = async (items) => {
    try {
        return await put('testimonials/reorder', { items });
    } catch (err) {
        return { error: err };
    }
};
